import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import type {IPlayer} from "data/stores/players/players.store";
import {Bindings} from "data/constants/bindings";
import type {ISquadsStore, ISquad} from "data/stores/squads/squads.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

interface IProps {
	player: IPlayer;
	contestId: number;
}

export interface IWinnerCardResultedController extends ViewController<IProps> {
	get squadByPlayer(): ISquad | null | undefined;

	openShareModal: () => void;
}

@injectable()
export class WinnerCardResultedController implements IWinnerCardResultedController {
	@observable private _player!: IPlayer;
	@observable private contestId!: number;

	get squadByPlayer() {
		if (!this._player) return null;

		return this._squadsStore.getSquadById(this._player.squadId);
	}
	constructor(
		@inject(Bindings.SquadsStore) public _squadsStore: ISquadsStore,
		@inject(Bindings.ModalsStore) public _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	init({player, contestId}: IProps) {
		this._player = player;
		this.contestId = contestId;
	}

	onChange(param: IProps) {
		this.init(param);
	}

	openShareModal = () => {
		const playerId = this._player.id ?? 0;
		const contestId = this.contestId ?? 0;

		if (playerId && contestId) {
			this._modalsStore.showModal(ModalType.SHARE_PICK, {
				playerId: playerId,
				contestId: this.contestId,
			});
		}
	};
}
